import { render, staticRenderFns } from "./AddCustomerNext.vue?vue&type=template&id=39f7cc19&scoped=true"
import script from "./AddCustomerNext.vue?vue&type=script&lang=ts"
export * from "./AddCustomerNext.vue?vue&type=script&lang=ts"
import style0 from "./AddCustomerNext.vue?vue&type=style&index=0&id=39f7cc19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f7cc19",
  null
  
)

export default component.exports